<template>
  <b-input-group size="sm" class="w-100 mx-2" style="max-width: 400px">
    <b-input-group-prepend>
      <b-input-group-text class="py-0">
        <b-icon-search></b-icon-search>
      </b-input-group-text>
    </b-input-group-prepend>
    <input
      v-model="query"
      placeholder="Buscar por nombre o clave"
      type="search"
      class="form-control"
      :disabled="!$store.getters['administrativeUnitModule/getAdministrativeUnits']"
      @keyup.enter="search"
    />
  </b-input-group>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdministrativeUnitSearch',

  data () {
    return {
      query: null
    }
  },

  computed: {
    ...mapGetters('administrativeUnitModule', ['isSearchingMode'])
  },

  watch: {
    isSearchingMode: {
      immediate: true,
      handler (value) {
        if (!value) return

        this.query = this.$store.state.administrativeUnitModule.query
      }
    },

    query: {
      immediate: true,
      handler (val) {
        if (!val) this.clear()
      }
    }
  },

  methods: {
    async search () {
      if (this.query === null || this.query === '') return

      this.$store.commit('administrativeUnitModule/setQuery', this.query)

      const { error, message } = await this.$store.dispatch('administrativeUnitModule/search', { search: this.query })

      if (error) this.$notify({ error, message }, 'Busqueda unidad administrativa')
    },

    async clear () {
      this.query = null
      this.$store.commit('administrativeUnitModule/setQuery', this.query)
      this.$store.dispatch('administrativeUnitModule/getAdministrativeUnits')
    }
  }
}
</script>
